/// <amd-module name="Core/Medius.Core.Web/Scripts/components/emailStatusTab/emailStatusTab"/>
import * as ko from 'knockout';
import { EmailStatusWithSections } from 'Core/Medius.Core.Web/Scripts/components/emailStatusTab/emailStatusWithSections';

export default class EmailStatusTab {
    public emailStatusWithSections: any;
    public documentId: string;
    public importTrackingId?: string | null;

    constructor(documentId?: string, importTrackingId?: string | null) {
        this.documentId = documentId || '0';
        this.importTrackingId = importTrackingId || undefined;
        this.emailStatusWithSections = ko.pureComputed(() => ({
            functionComponent: EmailStatusWithSections,
            props: {
                documentId: this.documentId,
                importTrackingId: this.importTrackingId,
            },
        }));
    }
}
